import React from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../../../redux/store'
import {HorizontalTableRow} from './HorizontalTableRow'

type Props = {
  className: string
}

export const HorizontalTable = ({className}: Props) => {
  const data = useSelector((state: RootState) => state.batchDetailsSlice)

  return (
    <div className={className}>
      <HorizontalTableRow
        title={'Total de registros'}
        description={data?.totalRecords.toString() || ''}
        icon={'/media/soyfri-media/user.svg'}
        color={'primary-dark'}
      />

      {data.invalidRecords && data.invalidRecords > 0 ? (
        <HorizontalTableRow
          title={'Registros inválidos'}
          description={data.invalidRecords.toString() || ''}
          icon={'/media/soyfri-media/danger.svg'}
          color={'danger'}
        />
      ) : null}

      <HorizontalTableRow
        title={'Registros válidos'}
        description={data?.validRecords.toString() || ''}
        icon={'/media/soyfri-media/exclamation.svg'}
        color={'primary-dark'}
      />
      <HorizontalTableRow
        title={'Monto original'}
        description={data?.totalAmount || ''}
        icon={'/media/soyfri-media/money-bill-wave.svg'}
        color={'primary'}
      />
      <HorizontalTableRow
        title={'Pago a realizar'}
        description={data?.payableAmount || ''}
        icon={'/media/soyfri-media/credit-card.svg'}
        color={'success'}
      />
    </div>
  )
}
